import { gql } from 'graphql-request';

export default gql`query($filter: FormInput) {
    article(filter: $filter) {
        id,
        message
    }
}`;